import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Typography, Alert } from '@mui/material';
import AddressForm from 'components/common/Forms/AddressForm/AddressForm';
import { GetAddressFLS } from '../../services/AddressService';
import { useAuth0 } from '@auth0/auth0-react';
import useApi, { Status } from '../../common/hooks/useApi';
import LoadingIndicator from 'components/common/LoadingIndicator';
import { Helmet } from 'react-helmet';

const EditAddress = (): JSX.Element => {
  const { t } = useTranslation('component');
  const { id } = useParams();
  const { user } = useAuth0();
  const [fetchAddress, addressInfo, fetchingAddressStatus, error] = useApi(GetAddressFLS);

  useEffect(() => {
    fetchAddress(user?.session_id, Number(id));
  }, [fetchAddress, user?.session_id, id]);

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow" />
        <title>{t('MetaTag.EditAddressTitle')}</title>
        <meta name="description" content={t('MetaTag.EditAddressDescription').toString()} />
      </Helmet>
      {fetchingAddressStatus == Status.Rejected && !String(error).includes('404') && (
        <Alert severity="error">{t('AddressForm.GetAddressError')}</Alert>
      )}
      {fetchingAddressStatus == Status.Rejected && String(error).includes('404') && (
        <Alert severity="error">{t('AddressForm.AddressNotFound')}</Alert>
      )}
      {fetchingAddressStatus != Status.Rejected && (
        <>
          <Typography variant="title">{t('AddressForm.EditAddressTitle')}</Typography>
          {addressInfo == undefined && <LoadingIndicator />}
          {addressInfo != undefined && <AddressForm address={addressInfo[0]} />}
        </>
      )}
    </>
  );
};

export default EditAddress;
